import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { registrationMethodClassConfig } from './RegistrationMethodClass.name';

/** 登録方法区分のENUM */
enum RegistrationMethodClass {
  singleReg = '1',
  dataImport = '2',
  multiReg = '3',
  bulkInstr = '4',
  incrDecrCancel = '5',
}

const registrationMethodClassMap = new Map([
  ['1', RegistrationMethodClass.singleReg],
  ['2', RegistrationMethodClass.dataImport],
  ['3', RegistrationMethodClass.multiReg],
  ['4', RegistrationMethodClass.bulkInstr],
  ['5', RegistrationMethodClass.incrDecrCancel],
]);

const rawValueToRegistrationMethodClass = rawValueToEnumWithDefault(
  registrationMethodClassMap,
  RegistrationMethodClass.singleReg,
);

const registrationMethodClassToDisplay = enumToNameWithDefault(
  RegistrationMethodClass,
  registrationMethodClassConfig,
);

export { RegistrationMethodClass, rawValueToRegistrationMethodClass, registrationMethodClassToDisplay };
